import {Grid} from '@mui/material';

import {
  diabetItems,
  genderItems,
  insulinItems,
  oralMedicationItems,
  pregnancyItems,
} from '../items';
import RadioField from './RadioField';
import WheelTextField from './WheelTextField';
import PregnancyRadio from './PregnancyRadio';

const OptionalFields = (props) => {
  const {values} = props;
  const isMale = values?.isMale ?? true;
  return (
    <>
      <Grid item xs={12}>
        <WheelTextField {...props} name='birthDate' label='تاریخ تولد' />
      </Grid>
      <Grid item xs={12}>
        <RadioField
          {...props}
          name='isMale'
          label='جنسیت'
          items={genderItems}
        />
      </Grid>{' '}
      <Grid item xs={12}>
        <WheelTextField
          {...props}
          name='yearsWithDiabet'
          label={'مدت زمان شروع دیابت'}
        />
      </Grid>{' '}
      <Grid item xs={12}>
        <RadioField
          {...props}
          name='diabetType'
          label='نوع دیابت'
          items={
            values['isMale']
              ? diabetItems.filter((item) => item.value !== 2)
              : diabetItems
          }
        />
      </Grid>
      <Grid item xs={12}>
        <RadioField
          {...props}
          name='insulinType'
          label='انسولین'
          items={insulinItems}
        />
      </Grid>
      <Grid item xs={12}>
        <RadioField
          {...props}
          name='isUsingOralMedications'
          label='داروی خوراکی'
          items={oralMedicationItems}
        />
      </Grid>
      {!isMale && (
        <Grid item xs={12}>
          <PregnancyRadio
            {...props}
            label={'وضعیت بارداری'}
            name={'isPregnant'}
            items={pregnancyItems}
          />
        </Grid>
      )}
    </>
  );
};

export default OptionalFields;
